import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearSelectedVisitImageAction,
  clearVisitImagesActions,
  getVisitImagesActions,
} from '../../../redux/actions/visitImagesActions';

const useFetchVisitImages = (visitId, vin) => {
  const dispatch = useDispatch();
  const visitImages = useSelector((state) => state.visitImages?.visitImages);
  const loading = useSelector((state) => state.visitImages?.loading);

  const fetchVisitImages = useCallback(async () => {
    await dispatch(getVisitImagesActions(visitId, vin));
  }, [visitId, vin, dispatch]);

  useEffect(() => {
    fetchVisitImages();
  }, [fetchVisitImages]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitImagesActions());
      dispatch(clearSelectedVisitImageAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisitImages();
  };

  return { loading, visitImages, refresh };
};

export default useFetchVisitImages;
